import swapVideoSource from "./swap-video-source";
import debounce from "lodash/debounce";

require("regenerator-runtime/runtime");

async function loadVideo() {
    if ($(".landing-page-hero:not(.autoplay-video) video").length == 0) return;

    const $video = $(".landing-page-hero video");

    const origSrc = await swapVideoSource($video, window.innerWidth < 768);
    $video[0].play();

    window.addEventListener("orientationchange", debounce(async () => {
        if (origSrc) {
            $video.attr("src", origSrc);
        }
        await swapVideoSource($video, window.innerWidth < 768);
        $video[0].play();
    }, 300))
}

$(async () => await loadVideo());

const isCorrectSource = (sourceUrl, mobileUrlCheck, mobileBreakPoint) => {
    if (!sourceUrl) return false;

    const isMobile = window.innerWidth < mobileBreakPoint;
    const isMobileSource = sourceUrl.endsWith(mobileUrlCheck);

    return (isMobile && isMobileSource) || (!isMobile && !isMobileSource);
};

const checkHeroVideo = async () => {
    const video = $(".landing-page-hero.autoplay-video video");
    if (video.length == 0) return;

    const videoSrc = video.find('source:first')?.attr("src") ?? video.attr("src");
    if (!videoSrc) return;

    const mobileSuffix = "-mobile.mp4";
    const desktopSuffix = ".mp4";
    const isMobileSrc = videoSrc.endsWith(mobileSuffix);
    const desktopSrc = isMobileSrc ? videoSrc.replace(mobileSuffix, desktopSuffix) : videoSrc;
    const mobileSrc = isMobileSrc ? videoSrc : videoSrc.replace(desktopSuffix, mobileSuffix);

    const updateVideoSource = () => {
        const videoSourceUrl = video.attr("src") ?? video.find('source:first')?.attr("src");
        const mobileBreakpoint = 768;
        if (!isCorrectSource(videoSourceUrl, mobileSuffix, mobileBreakpoint)) {
            video.attr("src", window.innerWidth < mobileBreakpoint ? mobileSrc : desktopSrc);
        }
    };

    window.addEventListener("resize", debounce(updateVideoSource, 300));
    updateVideoSource();
};


const initiateModalIFrame = () => {
    document.querySelectorAll(".youtube-modal-wrapper").forEach((modalWrapper) => {
        const videoWrapper = modalWrapper.querySelector(".video-wrap");
        const playButton = modalWrapper.querySelector(".play-button");
        const videoLink = modalWrapper.dataset.src;
        const iFrameTag = `<iframe class="embed-responsive-item" id="frmYoutube" src="${videoLink}?enablejsapi=1" allowFullScreen="allowfullscreen" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" width="850" height="480"></iframe>`;

        playButton.addEventListener("click", () => {
            videoWrapper.querySelector('.embed-responsive').innerHTML = iFrameTag;

            videoWrapper.classList.add("playing");
        })
    })
}

window.addEventListener("DOMContentLoaded", () => {
    checkHeroVideo();
    initiateModalIFrame();
})